export default {
  eyebrow: 'Portale partner',
  title: 'Calcolatore commissione di servizio',
  description: 'Stima il ricavo della commissione di servizio generato dai ristoranti sotto il tuo account partner.',
  toasts: {
    load_error: 'Impossibile caricare le impostazioni della commissione di servizio.',
  },
};
